import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import AddRoleAndPermissionBasicInformation from "./AddRoleAndPermissionBasicInformation";
import UserHeader from "./AddRoleAndPermissionHeader";
import AddRoleAndPermissionFooter from "./AddRoleAndPermissionFooter";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import AddRoleAndPermissionHeader from "./AddRoleAndPermissionHeader";
import useQuery from "hooks/useQuery";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { RoleAPI } from "api";
import { useLocation } from "react-router-dom";
import { customSettings } from "utils/customConfig";

const schema = yup
  .object({
    name: yup.string().required("This field is required."),
    active: yup.boolean().required("This field is required."),
    // permissions: yup.string().required("This field is required."),
    // userName: yup.string().required("This field is required."),
    // email: yup.string().required("This field is required."),
    // password: yup.string().required("This field is required."),
    // role: yup.string().required("This field is required."),
  })
  .required();

const AddRoleAndPermission = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let myData = { ...data };

    {
      myData.id = location?.state ? location?.state?.id : 0;
    }
    console.log(myData);

    try {
      await RoleAPI.post(myData);
      toast.success("Record updated successfully", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location.state) {
      reset(location.state);
    }
  }, []);
  return (
    <>
      <div className="py-2">
        <BreadCrumb />
      </div>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="g-3">
            <Col xs={12}>
              <AddRoleAndPermissionHeader />
            </Col>
            <Col lg={12}>
              <AddRoleAndPermissionBasicInformation />
              {/* <ProductUpload /> */}
              {/* <ProductDetails /> */}
              {/* <ProductSpecifications /> */}
            </Col>
            {/* <Col xs={12}>
              <CategoryFooter />
            </Col> */}
          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddRoleAndPermission;
